import { Injectable } from "@angular/core";
import { IID_EP_SUPPORT } from "@common/interfaces/interfaceData";
import { AbstractInterfaceDataQuery } from "../interfaceDataModel";
import { IIDepGisfoSupportStore } from "./iidEPGisfoSupport.store";
import { InterfaceDataQuery } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

@Injectable({
  providedIn: 'root'
})
@InterfaceDataQuery(InterfaceName.SUPPORT)
export class IIDepGisfoSupportQuery extends AbstractInterfaceDataQuery<IID_EP_SUPPORT> {

  constructor(protected store: IIDepGisfoSupportStore) {
    super(store);
  }
}
